/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { BaseLayout, ListViewLayout } from 'ui-library/dist/external/layouts'
import {
  DataTable,
  DataTableColumn as TD,
  DataTableHeader as TH,
  DataTableRow as TR,
  Detail,
  List,
  ListRow,
  ListRowItem,
  NavigationDrawer,
  Pagination,
  TabHeader
} from 'ui-library/dist/external/components'
import PlanAction from '../../../action/plan'
import r from '../../../util/Renderer'

function ListView(props) {
  const toolbar = { label: `プラン一覧`, items: props.accountMenu }
  const pagination = props.pagination

  const searchFunction = params => {
    const pagination = props.pagination.merge({ page: params.page, per_page: params.perPage })
    PlanAction.onSearch(pagination)
  }

  return (
    <React.Fragment>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />

      <BaseLayout>
        <ListViewLayout>
          <DataTable
            headers={[
              <TH key={1} width="5%" isNumber>
                ID
              </TH>,
              <TH key={2} width="20%">
                宿泊施設
              </TH>,
              <TH key={3} width="10%">
                プランコード
              </TH>,
              <TH key={3} width="10%">
                PMSコード
              </TH>,
              <TH key={4} width="55%">
                プラン名
              </TH>
            ]}
            rows={props.plans.map((plan, index) => (
              <TR key={index} onClick={() => PlanAction.toDetailView(plan.id)}>
                <TD isNumber>{plan.id}</TD>
                <TD>{plan.hotel_name}</TD>
                <TD>{plan.plan_code}</TD>
                <TD>{plan.pms_plan_code}</TD>
                <TD>{plan.name}</TD>
              </TR>
            ))}
          />
        </ListViewLayout>
        <Pagination
          name="pagination"
          perPage={props.pagination.per_page}
          total={props.pagination.total}
          page={props.pagination.page}
          prev={e => searchFunction(e.value)}
          next={e => searchFunction(e.value)}
          perPageChanged={e => searchFunction(e.value)}
        />
      </BaseLayout>

      {r.renderIf(props.showDetail)(
        <Detail showHeader showFooter onDeactivate={PlanAction.hideDetailView}>
          <TabHeader onClose={PlanAction.hideDetailView} tabs={[]} />
          <List>
            <ListRow>
              <ListRowItem width={'100%'} overline={`プランID`} primaryText={props.plan.id} />
              <ListRowItem width={'100%'} overline={`宿泊施設`} primaryText={props.plan.hotel_name} />
              <ListRowItem width={'100%'} overline={`プランコード`} primaryText={props.plan.plan_code} />
              <ListRowItem width={'100%'} overline={`プラン名`} primaryText={props.plan.name} wrapPrimary />
            </ListRow>
            {r.renderIf(props.plan.breakfasts && props.plan.breakfasts.length > 0)(
              <ListRow>
                {props.plan.breakfasts &&
                  props.plan.breakfasts.map(breakfast => (
                    <ListRowItem
                      width={'100%'}
                      overline={`(朝食) ID: ${breakfast.id}`}
                      primaryText={breakfast.name}
                      secondaryText={`${saleUnitLabel(breakfast.sale_unit)} ${breakfast.unit_price} 円`}
                    />
                  ))}
              </ListRow>
            )}
            {r.renderIf(props.plan.lunches && props.plan.lunches.length > 0)(
              <ListRow>
                {props.plan.lunches &&
                  props.plan.lunches.map(lunch => (
                    <ListRowItem width={'100%'} overline={`(昼食) ID: ${lunch.id}`} primaryText={lunch.name} secondaryText={`${saleUnitLabel(lunch.sale_unit)} ${lunch.unit_price} 円`} />
                  ))}
              </ListRow>
            )}
            {r.renderIf(props.plan.dinners && props.plan.dinners.length > 0)(
              <ListRow>
                {props.plan.dinners &&
                  props.plan.dinners.map(dinner => (
                    <ListRowItem width={'100%'} overline={`(夕食) ID: ${dinner.id}`} primaryText={dinner.name} secondaryText={`${saleUnitLabel(dinner.sale_unit)} ${dinner.unit_price} 円`} />
                  ))}
              </ListRow>
            )}
            {r.renderIf(props.plan.activities && props.plan.activities.length > 0)(
              <ListRow>
                {props.plan.activities &&
                  props.plan.activities.map(activity => (
                    <ListRowItem
                      width={'100%'}
                      overline={`(アクティビティ) ID: ${activity.id}`}
                      primaryText={activity.name}
                      secondaryText={`${saleUnitLabel(activity.sale_unit)} ${activity.unit_price} 円`}
                    />
                  ))}
              </ListRow>
            )}
          </List>
        </Detail>
      )}
    </React.Fragment>
  )
}

function saleUnitLabel(saleUnit) {
  switch (saleUnit) {
    case 'people_stay':
      return '一泊一人あたり'
    case 'people':
      return '一人あたり'
    case 'stay':
      return '一泊あたり'
    case 'once':
      return '一括'
    default:
      return ''
  }
}

export default ListView
